import React, { useEffect, useState } from "react";

/** MUI */
import { makeStyles } from "@mui/styles";
import { Autocomplete, TextField } from "@mui/material";

/** Redux */
import { useDispatch, useSelector } from "react-redux";
import { getSelectedJT, setSelectedJT } from "../../../../_appStore/DB_Lists_Table";
import { getSelectedTerritorialUnitsItems } from "../../../../_appStore/DB_JTs";

/** Helpers */
import _ from "lodash";
import { useTranslation } from "react-i18next";
import useHelper from "../../../../_common/useHelper";

const useStyles = makeStyles((theme) => ({}));

const ListJT = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { translationFromJson, getAllIDs } = useHelper();
    const { t } = useTranslation();

    /** States */
    const [VALUES, setVALUES] = useState(null);

    /** Redux selectors */
    const selectedJTs = useSelector(getSelectedTerritorialUnitsItems);
    const selectedJT = useSelector(getSelectedJT);

    /** Effects */
    /** - set list */
    useEffect(() => {
        const _sorted = JSON.parse(JSON.stringify(selectedJTs)).sort((a, b) => a.nazwa.localeCompare(b.nazwa));
        if (JSON.stringify(VALUES) !== JSON.stringify(_sorted)) {
            setVALUES(_sorted);
        }
    }, [VALUES, selectedJTs]);

    /** - set first if is not set any */
    useEffect(() => {
        // process.env.NODE_ENV === "development" && console.log({ selectedJTs, selectedJT });
        // if (!selectedJTs.length || selectedJT) return;
        if (!selectedJTs.length) return;
        const _all = getAllIDs(selectedJTs);
        if (selectedJT && _all?.map((a) => a.id)?.includes(selectedJT?.id)) {
            return;
        }
        dispatch(setSelectedJT(selectedJTs[0]));
    }, [selectedJTs, selectedJT]);

    /** Handlers */
    const handleOnChange = ({ newValue }) => dispatch(setSelectedJT(newValue));

    return (
        <>
            <div>
                {!!VALUES?.length && (
                    <Autocomplete
                        id="select-table-jt"
                        value={selectedJT}
                        onChange={(event, newValue) => handleOnChange({ newValue })}
                        isOptionEqualToValue={(option, value) => option.nazwa === value.nazwa}
                        // getOptionLabel={(option) => translationFromJson(option, "nazwa")}
                        getOptionLabel={(option) => translationFromJson(option, "nazwa") + ` (${option?.sym_kts})`}
                        options={VALUES}
                        sx={{ minWidth: 300, maxWidth: "50%" }}
                        fullWidth
                        renderInput={(params) => <TextField {...params} label={t("Wybierz jednostkę terytorialną")} />}
                        disableClearable
                        componentsProps={{
                            popupIndicator: {
                                "aria-label": t("Rozwiń listę"),
                                title: "",
                            },
                        }}
                    />
                )}
            </div>
        </>
    );
};

export default ListJT;
